import React, { useEffect } from 'react';

import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';
import coLogo from "../images/logo.png";

const AboutUs = () => {

    const { t, i18n } = useTranslation();
    const language = i18n.language;
    const isRTL = language === "ar" || language === "he";

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });  
    }, []);

    return (
        <div className="min-h-screen pt-10 pb-20 bg-background" dir={t('dir')}>
            <div className="container px-4 mx-auto">
                <div className="max-w-5xl mx-auto">

                    {/* عنوان About */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-center mb-16"
                    >
                        <h1 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900 dark:text-white">
                            {t('aboutUs')}
                        </h1>
                        <div className="h-1.5 w-24 bg-accent mx-auto rounded-full" />
                    </motion.div>

                    {/* نص + صورة */}
                    <div className="grid md:grid-cols-2 gap-12 items-start">
                        <div className="relative flex items-center justify-center">
                            {/* خلفية ملونة */}
                            <div className="absolute inset-0 rounded-3xl transform rotate-3 translate-x-2 translate-y-2 opacity-20" />
                            {/* الصورة */}
                            <img src={coLogo} alt={t('appName')} className="relative rounded-3xl max-w-full max-h-[180px] object-contain" />
                        </div>

                        <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
                            <p>
                                <strong>{t("aboutUsText1")}</strong> {t('aboutUsText')}</p>
                            <p>
                                {t('aboutUsText2')}
                            </p>
                            <p>
                                {t('aboutUsText3')}
                            </p>
                        </div>
                    </div>

                    {/* إحصائيات */}
                    <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="bg-slate-50 dark:bg-slate-800 p-8 rounded-2xl text-center">
                            <div className="text-4xl font-bold text-primary mb-2">70+</div>
                            <div className="text-muted-foreground font-medium">{t('yearsExperience')}</div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-800 p-8 rounded-2xl text-center">
                            <div className="text-4xl font-bold text-primary mb-2">30+</div>
                            <div className="text-muted-foreground font-medium">{t('modernBuses')}</div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-800 p-8 rounded-2xl text-center">
                            <div className="text-4xl font-bold text-primary mb-2">500k+</div>
                            <div className="text-muted-foreground font-medium">{t('happyPassengers')}</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );

};

export default AboutUs;
